<div class="surface-card p-4 shadow-2 border-round">

    <div style="align-items: center" class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
        <div class="flex justify-end md:justify-center" style="align-items: center">
            <div>
                <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">MOVIMENTAZIONI<span *ngIf="lockAzienda != null"> {{ this.lockAzienda.ragioneSociale}}</span></span>
            </div>
        </div>

        <div class="flex justify-end md:justify-center" style="margin-left: 1em">
            <button pButton type="button" icon="pi pi-download" class="p-button-rounded mr-2 p-button-outlined" tooltipPosition="top" pTooltip="Scarica lista movimentazioni" (click)="downloadDataAsXlsx()" style="background-color: rgb(148, 121, 206); color: white;"></button>
            <button pButton type="button" icon="pi pi-download" class="p-button-rounded mr-2 p-button-outlined"  tooltipPosition="top" pTooltip="Scarica dati materiali" (click)="downloadDataDetailAsXlsx()"  style="background-color: rgb(148, 121, 206); color: white;"></button>
            <button *ngIf="lockAzienda == null" pButton type="button" icon="pi pi-upload" class="p-button-rounded mr-2 p-button-outlined"  tooltipPosition="top" pTooltip="Carica allineamenti da file" (click)="uploadDataFromFile()" style="background-color: rgb(117, 189, 145); color: white;"></button>
        </div>

        <div style="flex-grow: 1"></div>


        <div class="flex justify-end md:justify-end form_row">
            <p-calendar selectionMode="range" [(ngModel)]="filterDatesRange" [readonlyInput]="true" [showClear]="true" [showButtonBar]="true" (onSelect)="updateFiltered()" (onClear)="updateFiltered()"></p-calendar>

            <div class="form_row_item">
                <p-dropdown styleClass="form_select_small" appendTo="body" [options]='optionsStatoFaseSpedizione' [(ngModel)]="filterStatoFaseSpedizione" placeholder="stato" (onChange)="updateFiltered()"></p-dropdown>
            </div>
            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsTypeFilter' [(ngModel)]="filterType" placeholder="tipo movimentazione" (onChange)="updateFiltered()"></p-dropdown>
            </div>
            <div class="form_row_item" *ngIf="this.lockAzienda == null">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsAzienda' [(ngModel)]="filterAzienda" placeholder="impresa riferimento" (onChange)="updateFiltered()"></p-dropdown>
            </div>

            <div class="form_row_item">
                <div class="p-inputgroup">

                    <p-dropdown styleClass="form_select_mid ddgroupright" appendTo="body" [options]='optionsTypeCreateNew' [(ngModel)]="currentTypeCreateNew" placeholder="crea movimentazione" ></p-dropdown>
                    <button pButton type="button" icon="pi pi-plus" pTooltip="crea movimentazione" tooltipPosition="top"
                        class="font-['Poppins']"
                        style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
                        [disabled]=" currentTypeCreateNew == null || !dataReady"
                        (click)="openItemCreateDialog(currentTypeCreateNew)"></button>
                </div>
            </div>
        </div>

    </div>

    <div fxFlex="95%">

        <p-table #comuniDT styleClass="p-datatable-sm" [value]="filteredMovimentazioni" dataKey="id"
                 [selectionPageOnly]="true" [rowHover]="true" [rows]="30" [showCurrentPageReport]="true"
                 [rowsPerPageOptions]="[30,50,100]" [loading]="!dataReady" responsiveLayout="stack" [paginator]="true"
                 currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                 [globalFilterFields]="['id','mittente.ragioneSociale']" [sortField]="'codice'" [sortOrder]="1">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="id">
                        <div class="flex justify-content-between align-items-center">
                            Identificativo
                            <p-sortIcon field="id"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="tipo">
                        <div class="flex justify-content-between align-items-center">
                            Tipo
                        </div>
                    </th>
                    <th pSortableColumn="origine.codice">
                        <div class="flex justify-content-between align-items-center">
                            Mittente
                            <p-sortIcon field="origine.codice"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="destinazione.codice">
                        <div class="flex justify-content-between align-items-center">
                            Destinatario
                            <p-sortIcon field="destinazione.codice"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="spedito">
                        <div class="flex justify-content-between align-items-center">
                            Spedita
                            <p-sortIcon field="spedito"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="consegnato">
                        <div class="flex justify-content-between align-items-center">
                            Consegnata
                            <p-sortIcon field="consegnato"></p-sortIcon>
                        </div>
                    </th>
                    <th>
                        <div class="flex justify-content-between align-items-center">
                            Azioni
                        </div>
                    </th>

                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-expanded="expanded">
                <tr class="compactdata">

                    <td>
                        <span class="text-lowercase">{{ row.id }}</span>
                    </td>
                    <td>
                        <span class="text-lowercase">
                             <p-tag
                                [style]="{
                                  'background-color': COLORS_MOVTYPE[row.tipo] ?? '#666666',
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ typeDescriptions[row.tipo] ?? row.tipo }}</p-tag>


                            <span *ngIf="row.correttivo_per != null">
                                <i class="pi pi-exclamation-circle" pTooltip="correttivo per {{row.correttivo_per}}`"></i>
                            </span>
                        </span>
                    </td>
                    <td><span class="text-lowercase">
                        <span *ngIf="row.mittente != null">
                            <p-tag
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{row.origine.codice}} ({{ row.mittente.ragioneSociale }})</p-tag>
                        </span>
                        <span *ngIf="row.mittente == null && row.tipo == TipoMovimentazione.INSTALLAZIONE_RIENTRO && row.pratica != null">
                            <p-tag
                                [style]="{
                                  'background-color': '#78c0e0' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ scuoleByPratica[row.pratica].pratica.cui }}</p-tag>
                        </span>
                    </span></td>
                    <td><span class="text-lowercase">
                        <span *ngIf="row.destinatario != null">
                            <p-tag
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ row.destinazione.codice}} ({{ row.destinatario.ragioneSociale }})</p-tag>
                        </span>
                        <span *ngIf="row.destinatario == null && row.pratica != null && row.tipo != TipoMovimentazione.INSTALLAZIONE_RIENTRO">
                            <p-tag
                                [style]="{
                                  'background-color': '#78c0e0' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ scuoleByPratica[row.pratica].pratica.cui }}</p-tag>
                        </span>
                    </span>
                    </td>
                    <td>
                        <span *ngIf="row.consegnato == null" style="font-weight: bold">
                            {{ row.spedito }}
                        </span>
                        <span *ngIf="row.consegnato != null">
                            {{ row.spedito }}
                        </span>
                    </td>
                    <td>
                        {{ row.consegnato }}

                    </td>
                    <td>

                        <button pButton type="button" icon="pi pi-stopwatch" class="p-button-rounded p-button-text"
                                tooltipPosition="top" style="color: red" pTooltip="Spedizione in ritardo" *ngIf="row.consegna_scaduta"
                                (click)="handleOutOfTime(row)">
                        </button>

                        <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-upload" class="p-button-rounded p-button-text"
                                tooltipPosition="top" pTooltip="Registra spedizione" *ngIf="row.origine != null && row.spedito == null"
                                (click)="openMovimentazioneTransferDialog(row, false)">
                        </button>

                        <button pButton type="button" style="color: darkgreen" class="p-button-rounded p-button-text"
                                tooltipPosition="top" pTooltip="Registra consegna"  *ngIf="row.allowConfirmDelivery && (!row.allowFillInstallationForm)"
                                (click)="openMovimentazioneTransferDialog(row, true)">
                            <i class="material-symbols-outlined mr-2"> hand_package </i>

                        </button>

                        <button pButton pRipple type="button" icon="pi pi-trash" *ngIf="row.spedito == null && row.consegnato == null"
                                class="p-button-rounded p-button-text" (click)="openItemDeleteDialog(row)" style="color:red;" tooltipPosition="top" pTooltip="Elimina movimentazione">
                        </button>
                        <span *ngIf="row.discrepanza != null">
                            <button pButton pRipple type="button" icon="pi pi-exclamation-triangle" *ngIf="row.discrepanza.stato == StatoDiscrepanza.SEGNALATA && row.allowFixInconsistency" class="p-button-rounded p-button-text" (click)="openInconsistencyHandling(row)" style="color:red;" tooltipPosition="top" pTooltip="Gestisci discrepanza">
                            </button>
                            <button pButton pRipple type="button" icon="pi pi-exclamation-triangle" *ngIf="row.discrepanza.stato == StatoDiscrepanza.SEGNALATA && !row.allowFixInconsistency" class="p-button-rounded p-button-text" style="color:lightgray;" tooltipPosition="top" pTooltip="segnalata discrepanza">
                            </button>
                        </span>


                        <span style="background: #c4c489">
                            <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-inbox" class="p-button-rounded p-button-text"
                                    tooltipPosition="top" pTooltip="Consulta pratica" *ngIf="row.allowFillInstallationForm"
                                    (click)="openPagePraticaMovimentazione(row)">
                            </button>


                            <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-file-edit" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Registra installazione"  *ngIf="row.allowFillInstallationForm"
                                    (click)="openInstallationForm(row )">
                            </button>
                            <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-file-edit" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Annulla installazione"  *ngIf="row.allowFillInstallationForm"
                                    (click)="cancelInstallation(row )">
                            </button>
                        </span>

                        <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-info-circle" class="p-button-rounded p-button-text"
                                tooltipPosition="top" pTooltip="Materiali" [pRowToggler]="row">
                        </button>

                        <div style="display: inline-block"  *ngIf="row.note">
                            <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-question-circle" class="p-button-rounded p-button-text" (click)="op.toggle($event)" tooltipPosition="top" pTooltip="{{row.note}}">
                            </button>
                            <p-overlayPanel #op appendTo="body">
                                <textarea [disabled]=true rows="5" cols="30" pTextarea>{{row.note}}</textarea>
                            </p-overlayPanel>
                        </div>


                    </td>


                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-row>
                <tr>
                    <td colspan="7">
                        <p-table [value]="row.materiali" dataKey="info.nmu">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="info.nmu">NMU<p-sortIcon field="info.nmu"></p-sortIcon></th>
                                    <th pSortableColumn="info.descrizione">Descrizione <p-sortIcon field="info.descrizione"></p-sortIcon></th>
                                    <th pSortableColumn="qt">Quantità <p-sortIcon field="qt"></p-sortIcon></th>
                                    <th>Valore</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>{{ item.info.nmu }}</td>
                                    <td>{{ item.info.descrizione }}</td>
                                    <td>{{ item.qt }}</td>
                                    <td>{{ item.qt * item.info.listino }} €</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </td>
                </tr>
            </ng-template>

        </p-table>

    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"></p-confirmDialog>

<p-toast position="top-center"></p-toast>
